/**
 * Specifies the party's or parties' intention to clear the trade.
 * tag: 1924
 * @readonly
 * @enum {number} (int)
 */
export enum ClearingIntention {
  /** Do not intend to clear */
  DoNotIntendToClear = 0,
  /** Intend to clear */
  IntendToClear = 1,
}
